import {
  PanelToggleButton,
  PanelToggleIcon,
} from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/styled-components'
import RailHoverBubble from '@/shared/components/RailHoverBubble/RailHoverBubble'
import useRailHoverLabel from '@/shared/components/RailHoverBubble/useRailHoverLabel'
import useSidebarMenuToggle from '@/hoc/SidebarMenu/bones/useSidebarMenuToggle'
import { StyledMenuToggleRow } from '@/hoc/SidebarMenu/styled-components'

interface SidebarMenuToggleProps {
  expanded: boolean
  onToggle: () => void
}

const SidebarMenuToggle = ({ expanded, onToggle }: SidebarMenuToggleProps) => {
  const { Icon, iconColor, label } = useSidebarMenuToggle(expanded)
  const { anchorRef, geometry, show, hide } = useRailHoverLabel<HTMLButtonElement>()

  return (
    <StyledMenuToggleRow>
      <PanelToggleButton
        ref={anchorRef}
        type='button'
        data-menu-toggle
        $expanded={expanded}
        aria-expanded={expanded}
        aria-label={label}
        onClick={onToggle}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        <PanelToggleIcon key={String(expanded)}>
          <Icon size={20} color={iconColor} />
        </PanelToggleIcon>
      </PanelToggleButton>
      <RailHoverBubble geometry={geometry} label={label} />
    </StyledMenuToggleRow>
  )
}

export default SidebarMenuToggle
